import React from "react";
import { observer } from "mobx-react";

function ContentSyncModalTemplate() {
    return <div></div>;
}

export default observer(ContentSyncModalTemplate);
